var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5L9.14205 9.15339C9.06189 10.1954 8.19301 11 7.14794 11H4.85206C3.80699 11 2.93811 10.1954 2.85795 9.15339L2.5 4.5M10.5 3.5C9.20104 2.86699 7.65683 2.5 6 2.5C4.34317 2.5 2.79896 2.86699 1.5 3.5M5 2.5V2C5 1.44772 5.44772 1 6 1C6.55228 1 7 1.44772 7 2V2.5M5 5.5V8.5M7 5.5V8.5",
    stroke: "#FFBE1D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline2);
export default __webpack_public_path__ + "static/media/trash-outline-2.53f6de06d3f747c4e9968a5705200128.svg";
export { ForwardRef as ReactComponent };